import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common'

class MagstimTableInsuranceProvider extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
				{ title: CurrentLang().insurance_provider_name, property: 'Name', isSearchable: true},
				{ title: CurrentLang().insurance_provider_details, property: 'Details', isSearchable: true},
			],
			data: data
		};
	}
}

export default MagstimTableInsuranceProvider;